import { tv } from 'tailwind-variants';

import { Loader } from '@elements/loader';

import { getRadioVariant } from './radio.utils';

const radioIndicatorStyles = tv({
  base: 'w-6 h-6 flex items-center justify-center rounded-full border-2 transition-all bg-surface-primary border-border-bold peer-hover:border-border-action-hover',
  variants: {
    variant: {
      active: 'border-border-action-active',
      disabled: 'border-border-disable bg-surface-disabled peer-hover:border-border-disable',
    },
  },
});

const radioInnerCircleStyles = tv({
  base: 'w-4 h-4 rounded-full',
  variants: {
    variant: {
      active: 'bg-border-action-active',
      disabled: '',
    },
  },
});

type RadioIndicatorProps = {
  checked?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
};

export const RadioIndicator = ({ checked, disabled, isLoading }: RadioIndicatorProps) => {
  const variant = getRadioVariant(disabled, checked);

  return (
    <div className={radioIndicatorStyles({ variant })}>
      {isLoading ? (
        <Loader className="text-disabled w-4 h-4" />
      ) : (
        <div
          className={radioInnerCircleStyles({
            variant,
          })}
        />
      )}
    </div>
  );
};
